import React, { Component } from "react";
import { Spin, Select } from "antd";
import DoctorDetailsTabView from "./DoctorDetailsTabView";
import { getDoctorDetails, getDoctorProfile } from "../../services";
import { showErrorNotification, getProp } from "../../helpers";

const { Option } = Select;

/**
 * @function getCurrentTabName
 * @params pathName
 * @description It will return the current active tab
 */
const getCurrentTabName = pathName => {
  let currentPage = null;
  // get pathName like '/settings/vitals'
  // find the number of `/` and get the array length
  const pathLength = (pathName.match(new RegExp("/", "g")) || []).length;
  // if pathName has only 1 '/'
  if (pathLength === 1) {
    currentPage = pathName.replace("/", "");
  } else if (pathLength === 2) {
    const path1 = pathName.substring(1).split("/")[0];
    currentPage = path1;
  } else {
    // if pathName has 2 '/'  like '/settings/network
    const path = pathName.substring(1).split("/")[2];

    currentPage = path;
  }

  return currentPage;
};

export default class DoctorDetailsTabsContainer extends Component {
  constructor(props) {
    super(props);
    const { doctorId, clinicDocId, clinicId } = this.props.match.params;
    this.state = {
      doctorId: doctorId,
      clinicDocId: clinicDocId,
      clinicId: clinicId
    };
  }
  componentDidMount() {
    const { doctorId, clinicDocId, clinicId } = this.props.match.params;

    this.state = {
      doctorId: doctorId,
      clinicDocId: clinicDocId,
      clinicId: clinicId
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    // get pathname like '/settings/vitals' from url
    const pathName = nextProps.location.pathname;

    const currentPage = getCurrentTabName(pathName);
    if (!prevState.currentPath !== currentPage) {
      return { currentPath: currentPage };
    }
    return null;
  }

  render() {
    const { currentPath, doctorId, clinicDocId, clinicId } = this.state;

    return (
      <div className="reputation-wrapper">
        <div className="content-container">
          {/* heading block start */}
          <div className="heading">
            <div className="left">Doctor Details</div>
          </div>
          {/* heading block end */}
          <DoctorDetailsTabView
            currentPath={currentPath}
            doctorId={doctorId}
            clinicDocId={clinicDocId}
            clinicId={clinicId}
          />
        </div>
      </div>
    );
  }
}
